<div class="card min-h-screen flex align-items-center flex-column justify-content-center overflow-hidden">
  <div class="text-center -mt-8 mb-8">
    <div class="text-blue-500 font-bold text-3xl">{{ leadIn }}</div>
    <h1 class="text-900 font-bold text-3xl lg:text-5xl mb-2">{{ header }}</h1>
    <div class="text-600 font-medium line-height-3">{{ followupText }}</div>
  </div>
  <ng-content></ng-content>
</div>
